/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface DossierAdmissionFichierUploadDto
 */
export interface DossierAdmissionFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof DossierAdmissionFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierUploadDto
     */
    iddossierAdmissionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierUploadDto
     */
    iddossierAdmission?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierAdmissionFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DossierAdmissionFichierUploadDto interface.
 */
export function instanceOfDossierAdmissionFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DossierAdmissionFichierUploadDtoFromJSON(json: any): DossierAdmissionFichierUploadDto {
    return DossierAdmissionFichierUploadDtoFromJSONTyped(json, false);
}

export function DossierAdmissionFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DossierAdmissionFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'iddossierAdmissionFichier': !exists(json, 'iddossierAdmissionFichier') ? undefined : json['iddossierAdmissionFichier'],
        'iddossierAdmission': !exists(json, 'iddossierAdmission') ? undefined : json['iddossierAdmission'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DossierAdmissionFichierUploadDtoToJSON(value?: DossierAdmissionFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'iddossierAdmissionFichier': value.iddossierAdmissionFichier,
        'iddossierAdmission': value.iddossierAdmission,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

